import React from "react";
import ReactDOM from "react-dom";
import "./styles/main.scss";
import App from "./App";
import ContextProvider from "./Context";
import { cleanExpiredCache } from "./utils/cache";
cleanExpiredCache();

ReactDOM.render(
	<React.StrictMode>
		<ContextProvider>
			<App />
		</ContextProvider>
	</React.StrictMode>,
	document.getElementById("root")
);
